export default function filterByField(fieldName, available, fieldValues) {
  const fieldValuesMap = new Set(fieldValues);
  return available?.filter((obj) => {
    return fieldValuesMap.has(obj[fieldName]) ?? [];
  });
}
